function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ApiClientCart from './api-client-cart';
import ApiClientCategory from './api-client-category';
import ApiClientClientOrder from './api-client-client-order';
import ApiClientCustomer from './api-client-customer';
import ApiClientOrder from './api-client-order';
import ApiClientProduct from './api-client-product';
import ApiClientQuote from './api-client-quote';
import ApiClientBulkOrder from './api-client-bulk-order';
import ApiClientAccessory from './api-client-accessory';
import ApiClientWarranty from './api-client-warranty';
import ApiClientPrice from './api-client-price';
import ApiClientProductOrder from './api-client-product-order';
import ApiClientPromotion from './api-client-promotion';
import ApiClientPaymentTransaction from './api-client-payment-transaction';
import ApiClientUserManagement from './api-client-user-management';
import ApiClientServiceOrder from './api-client-service-order';
/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClient = /*#__PURE__*/function () {
  function ApiClient() {
    _classCallCheck(this, ApiClient);
  }
  return _createClass(ApiClient, [{
    key: "setToken",
    value:
    /**
     * Load token from a script element
     * @param {String} token  The token to use when calling the api
     */
    function setToken(token) {
      this.cart = new ApiClientCart(token);
      this.category = new ApiClientCategory(token);
      this.bulkOrder = new ApiClientBulkOrder(token);
      this.clientOrder = new ApiClientClientOrder(token);
      this.productOrder = new ApiClientProductOrder(token);
      this.customer = new ApiClientCustomer(token);
      this.order = new ApiClientOrder(token);
      this.product = new ApiClientProduct(token);
      this.quote = new ApiClientQuote(token);
      this.accessory = new ApiClientAccessory(token);
      this.warranty = new ApiClientWarranty(token);
      this.price = new ApiClientPrice(token);
      this.promotion = new ApiClientPromotion(token);
      this.paymentTransaction = new ApiClientPaymentTransaction(token);
      this.userManagement = new ApiClientUserManagement(token);
      this.serviceOrder = new ApiClientServiceOrder(token);
    }

    /**
     * Initialize error handling
     * @param {function} callback Callback method called when an http error occurs
     */
  }, {
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.cart.initErrorHandling(callback);
      this.category.initErrorHandling(callback);
      this.clientOrder.initErrorHandling(callback);
      this.customer.initErrorHandling(callback);
      this.order.initErrorHandling(callback);
      this.product.initErrorHandling(callback);
      this.promotion.initErrorHandling(callback);
      this.paymentTransaction.initErrorHandling(callback);
      this.userManagement.initErrorHandling(callback);
      this.serviceOrder.initErrorHandling(callback);
    }
  }]);
}();
var Client = new ApiClient();
export default Client;